export default __webpack_public_path__ + "108f0484c12cea86907703ae2b6bab39.png";